// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoldFilledSvg from "@fishx/icons-svg/es/asn/GoldFilled";
import FishxIcon from '../components/FishxIcon';

var GoldFilled = function GoldFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoldFilledSvg
  }));
};

GoldFilled.displayName = 'GoldFilled';
export default React.forwardRef(GoldFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GoldFilled.js
// module id = 2884
// module chunks = 0